import { CommonUtils } from './../../../shared/utils/common-utils';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, NgModel } from '@angular/forms';
import * as moment from 'moment';

import { MWService } from "src/main-workflow/mw.service";
import { mwMoments } from 'src/main-workflow/mw.moments';

import { AppConfig } from 'src/shared/providers/config';
import { Certification } from 'src/providers/certification/certification';
import { ClaimJobs } from 'src/providers/claim-jobs/claim-jobs';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Homekeepers } from 'src/providers/homekeepers/homekeepers';
import { Me } from 'src/shared/providers/me';
import { Team } from 'src/providers/team/team';
import { HttpClient } from 'src/shared/providers/http/http-client';

import { InAppBrowserUtils } from 'src/shared/utils/in-app-browser-utils';
import promiseUtils from 'src/shared/utils/promise-utils';
import { TimePipe } from 'src/shared/pipes/tidy-time';
import { FormatDateTimePipe } from 'src/shared/pipes/format-date-time.pipe';
import { removeCurrencyMask } from 'src/shared/utils/currency-utils';

import { CertificationsModel } from 'src/shared/models/certification.model';
import { Credentials, CredentialTypeModel, AddCredentialParams } from 'src/providers/credentials/credentials';
import { Aws } from 'src/shared/providers/aws';
import { FilePicker } from 'src/shared/providers/file-picker/file-picker';
import { randomUUID } from 'src/tidy-ui-components/utils/secure-utils';
import { SuccessPageParamsModel } from 'src/pages/success/success';
import { generateTimeStamp } from 'src/providers/tidy-session/session-uuid';
import { Loading } from 'src/shared/components/loading/loading';
import { Router, ActivatedRoute } from '@angular/router';
import { TimeoutErrorHandler } from 'src/shared/providers/http/timeout-error-handler';
import { Timeout } from 'src/shared/components/timeout/timeout';
import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import * as Sentry from "@sentry/angular";
import { PrivateClient } from 'src/providers/private-client/private-client';

declare const mapboxgl: any;

@Component({
  selector: 'claim-job',
  templateUrl: './claim-job.html',
  styleUrls: ['./claim-job.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClaimJobPage extends Timeout implements OnInit {

  apiError: string;
  bookingFormAnswers: any;
  currentWeek: any;
  jobsFromSameClient: any;
  select: string;
  selectedCleaningTime: string;
  form: UntypedFormGroup;
  priceLaterForm: UntypedFormGroup;
  cleaning;
  didGoLive: boolean;
  today: string;
  jobsFromClientCount: number;
  homeLongitude: any;
  homeLatitude: any;
  bookingProtection = true;
  cleaningEndTime: string;
  pageTitle: string;
  countdownTarget: moment.Moment;
  confirmingPlanCoop = false;
  planDates: any[] = [];
  map: any = {};
  claimButtonDisabled = true;
  mapUid: string;
  hasTeamMembers: boolean;
  jobTimeItems: any;
  jobsGroupedByJobId: any;
  privateClients: any[] = [];
  submitted = false;
  quoteDaysAndTimes: any[] = []; // Array of { date: string, dateLabel: string, times: Array<{time: string, timeLabel: string, selected: boolean}> }
  allJobOpportunities: any[] = []; // Store all opportunities for the job to aggregate quotes
  credentialRequirements: any;
  mandatoryCredentials: { key: string; label: string; requirement_satisfied: boolean }[] = [];
  preferredCredentials: { key: string; label: string; requirement_satisfied: boolean }[] = [];
  meetsMandatory = true;
  justSubmittedCredential = false;
  credentialTypes: CredentialTypeModel[] = [];
  inlineCredentialFields: any[] = [];
  credentialForm: UntypedFormGroup;

  constructor(
    private certification: Certification,
    private claimJobs: ClaimJobs,
    private navCtrl: CustomNavController,
    private fb: UntypedFormBuilder,
    private iabUtils: InAppBrowserUtils,
    private homekeepers: Homekeepers,
    public me: Me,
    private mwService: MWService,
    private team: Team,
    private timePipe: TimePipe,
    private tidyDatePipe: FormatDateTimePipe,
    timeoutErrorHandler: TimeoutErrorHandler,
    router: Router,
    private route: ActivatedRoute,
    private utils: CommonUtils,
    private privateClient: PrivateClient,
    private httpClient: HttpClient,
    private credentialsProvider: Credentials,
    private aws: Aws,
    private filePicker: FilePicker
  ) {
    super(timeoutErrorHandler, router, route);
    this.form = this.fb.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      select: ['', Validators.required],
      lastName: ['', Validators.required],
      jobTime: ['', Validators.required]
    });
    this.priceLaterForm = this.fb.group({
      amount: ['', Validators.required],
      notes: ['']
    });
    this.credentialForm = this.fb.group({});
  }

  ngOnInit(): void {
    this.mapUid = `map-${generateTimeStamp()}`;
  }

  @Loading()
  async ionViewDidEnter() {
    try {
      this.loaded = false;
      this.today = moment().format('YYYY-MM-DD');
      const returnedFromCredential = this.navCtrl.getParam('returnedFromCredential');
      if (returnedFromCredential) {
        this.justSubmittedCredential = true;
      }
      this.cleaning = this.navCtrl.getParam('cleaning', false);
      const jobId = this.route.snapshot.paramMap.get('cleaningId') || this.cleaning?.job_id;
      const jobOpportunitiesForJob = await this.homekeepers.getJobOpportunitiesForJob(jobId);
      if (!this.cleaning) {
        this.cleaning = jobOpportunitiesForJob[0];
        if (!this.cleaning) {
          return this.showCleaningNoLongerAvailable();
        }
        await this.getHkHomeData();
        if (this.cleaning.homekeeper_preferences.gender == 'female' ||  this.cleaning.homekeeper_preferences.gender == 'male') {
          this.hasTeamMembers = await this.team.getIfHasTeamMembers();
        }
      } else {
        this.homeLongitude = this.navCtrl.getParam('homeLongitude');
        this.homeLatitude = this.navCtrl.getParam('homeLatitude');
        this.hasTeamMembers = this.navCtrl.getParam('hasTeamMembers');
      }
      this.allJobOpportunities = jobOpportunitiesForJob; // Store for quote aggregation
      this.parseCredentialRequirements();
      this.credentialTypes = await this.credentialsProvider.getCredentialTypes();
      this.buildInlineCredentialForms();
      this.patchLastSentQuote();
      const jobsByJobIDData: any = await this.claimJobs.parseDays(jobOpportunitiesForJob);
      this.jobsGroupedByJobId = jobsByJobIDData.currentWeek.jobs;
      this.jobsFromClientCount = this.getJobsFromClientCount();
      this.buildQuoteDaysAndTimes();
      this.cleaningEndTime = moment(this.cleaning.date).add(60, 'm').format('HH:mm');
      this.pageTitle = this.cleaning.type === 'cleaning' ? 'Add Job' : 'Add Plan';
      this.today = moment().format('YYYY-MM-DD');
      this.countdownTarget = moment().add(5, 'seconds');
      const certification: CertificationsModel = await this.certification.getCertifications();
      this.didGoLive = certification.steps.go_live === 'complete';
      this.jobTimeItems = await this.buildJobTimeItems();
      this.form.patchValue({jobTime: this.cleaning.emergency_cleaning_request_id});
      this.jobsGroupedByJobId.map((group) => {
        group.jobs.map((job) => {
          if (job.emergency_cleaning_request_id == this.cleaning.emergency_cleaning_request_id) {
            this.selectedCleaningTime = job.time;
          }
        });
      });
      if (!this.cleaning.service_type_details.key.includes('regular_cleaning')) {
        this.bookingFormAnswers = await this.me.getBookingFormAnswers(this.cleaning.job_id);
      }
      try {
        this.privateClients = await this.privateClient.getPrivateClients();
      } catch (err) {
        this.timeoutHandler(err);
      }
      this.loaded = true;
      await this.setMap();
    } catch (err) {
      this.utils.showError('Error loading claim job page: ' + err);
      const errorMessage = err?.message || err?.error?.message || 'Unknown error';
      Sentry.captureException(err, {
        tags: {
          page: 'claim-job',
          error: errorMessage
        }
      });
      this.timeoutHandler(err);
    }
  }

  parseCredentialRequirements() {
    const cr = this.cleaning?.credential_requirements;
    if (!cr) {
      this.credentialRequirements = null;
      this.mandatoryCredentials = [];
      this.preferredCredentials = [];
      this.meetsMandatory = true;
      return;
    }
    this.credentialRequirements = cr;
    this.meetsMandatory = cr.mandatory_requirements_satisfied !== false;

    const labels = cr.labels || {};
    const unsatisfiedMandatory = cr.unsatisfied_mandatory || [];
    const unsatisfiedPreferred = cr.unsatisfied_preferred || [];

    this.mandatoryCredentials = (cr.mandatory || []).map(key => ({
      key,
      label: labels[key] || key,
      requirement_satisfied: !unsatisfiedMandatory.includes(key)
    }));

    this.preferredCredentials = (cr.preferred || []).map(key => ({
      key,
      label: labels[key] || key,
      requirement_satisfied: !unsatisfiedPreferred.includes(key)
    }));
  }

  buildInlineCredentialForms() {
    const unsatisfied = this.mandatoryCredentials.filter(c => !c.requirement_satisfied);
    const controls: Record<string, any> = {};
    this.inlineCredentialFields = unsatisfied.map(cred => {
      const config = this.credentialTypes.find(ct => ct.key === cred.key);
      const formOptions = config?.form_options || {};
      const inputType = formOptions.input_type || 'file';
      if (inputType === 'url' || inputType === 'textarea' || inputType === 'number') {
        controls[cred.key] = ['', Validators.required];
      } else {
        controls[cred.key] = [''];
      }
      return {
        key: cred.key,
        label: config?.key_label || cred.label,
        inputType,
        placeholder: formOptions.placeholder || (inputType === 'url' ? 'https://...' : ''),
        isProfileImage: cred.key === 'profile_image',
        toggleValue: false,
        uploadedFileUrl: null,
        uploadedFileName: null,
        uploadedImages: [],
        isUploading: false,
        showError: false
      };
    });
    this.credentialForm = this.fb.group(controls);
  }

  validateInlineCredentials(): boolean {
    if (this.inlineCredentialFields.length === 0) return true;
    let hasError = false;
    for (const field of this.inlineCredentialFields) {
      if (field.inputType === 'url' || field.inputType === 'textarea' || field.inputType === 'number') {
        const value = this.credentialForm.get(field.key)?.value;
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          field.showError = true;
          hasError = true;
        } else {
          field.showError = false;
        }
      } else if (field.inputType === 'file') {
        if (!field.uploadedFileUrl) {
          field.showError = true;
          hasError = true;
        } else {
          field.showError = false;
        }
      } else if (field.inputType === 'toggle') {
        field.showError = false;
      }
    }
    return !hasError;
  }

  async submitInlineCredentials(): Promise<void> {
    for (const field of this.inlineCredentialFields) {
      const data: AddCredentialParams = { credential_type_key: field.key };
      if (field.inputType === 'url' || field.inputType === 'textarea') {
        data.text_value = this.credentialForm.get(field.key).value;
      } else if (field.inputType === 'number') {
        data.text_value = String(this.credentialForm.get(field.key).value);
      } else if (field.inputType === 'toggle') {
        data.text_value = field.toggleValue ? 'true' : 'false';
      } else if (field.inputType === 'file') {
        data.file_url = field.uploadedFileUrl;
      }
      await this.credentialsProvider.addCredential(data);
    }
  }

  async onInlineFileAdded(field: any, images: any[]) {
    field.isUploading = true;
    field.showError = false;
    try {
      const image = images[images.length - 1];
      const s3Key = `homekeeper-credentials/${randomUUID()}`;
      const response = await this.aws.uploadImageToS3(image.url, s3Key, image.file, image.exif);
      field.uploadedFileUrl = response.Location;
      field.uploadedImages = images;
    } catch (err) {
      field.uploadedImages = [];
      field.uploadedFileUrl = null;
    } finally {
      field.isUploading = false;
    }
  }

  async pickInlineFile(field: any) {
    field.isUploading = true;
    field.showError = false;
    try {
      const file = await this.filePicker.pickFile();
      const fileName = file.filename.replace(/ /g, '');
      const s3Key = `homekeeper-credentials/${randomUUID()}/${fileName}`;
      const response = await this.aws.uploadFileToS3(file.dataUrl, s3Key, file.format);
      field.uploadedFileUrl = response.Location;
      field.uploadedFileName = fileName;
    } catch (err) {
      if (err?.message?.includes('cancelled')) return;
      field.uploadedFileUrl = null;
      field.uploadedFileName = null;
    } finally {
      field.isUploading = false;
    }
  }

  onInlineFileRemoved(field: any) {
    field.uploadedImages = [];
    field.uploadedFileUrl = null;
    field.uploadedFileName = null;
  }

  onInlineFileError(field: any, error: any) {
    field.showError = true;
  }

  onInlineToggleChange(field: any, value: boolean) {
    field.toggleValue = value;
  }

  async navigateToAddCredential(credentialKey: string) {
    try {
      const existingCredentials = await this.credentialsProvider.getCredentials();
      const existing = existingCredentials.find(
        c => c.credential_type.key === credentialKey && c.status !== 'rejected'
      );
      if (existing) {
        this.justSubmittedCredential = true;
        this.parseCredentialRequirements();
        return;
      }
    } catch (err) {
      // If check fails, proceed to add page
    }
    const config = this.credentialTypes.find(ct => ct.key === credentialKey);
    const category = config?.category || 'certification';
    this.navCtrl.navigateForward('add-credential', {
      category,
      type: credentialKey,
      returnTo: 'claim-job',
      cleaningId: this.cleaning?.job_id
    });
  }

  getAllQuotesForJob(): any {
    if (!this.cleaning?.job_id || !this.allJobOpportunities || this.allJobOpportunities.length === 0) {
      return this.cleaning?.vendor_outreach_request_quote || null;
    }

    // Find all opportunities with the same job_id that have quotes
    const allQuotes = this.allJobOpportunities
      .filter(opp => opp.job_id === this.cleaning.job_id && opp.vendor_outreach_request_quote)
      .map(opp => opp.vendor_outreach_request_quote);

    if (allQuotes.length === 0) {
      return this.cleaning?.vendor_outreach_request_quote || null;
    }

    // Aggregate quotes - collect all times and dates, use first quote's other data
    const firstQuote = allQuotes[0];
    const allTimes = allQuotes
      .map(q => q?.time)
      .filter(time => time)
      .sort()
      .join(', ');

    // Collect all unique dates
    const allDates = allQuotes
      .map(q => q?.date)
      .filter(date => date)
      .filter((date, index, self) => self.indexOf(date) === index) // Get unique dates
      .sort((a, b) => moment(a).diff(moment(b))); // Sort chronologically

    return {
      id: firstQuote.id,
      amount: firstQuote.amount,
      date: firstQuote.date,
      dates: allDates, // Array of all unique dates
      time: allTimes, // Concatenated times
      times: allTimes.split(', '), // Array of times for display
      homekeeper_notes: firstQuote.homekeeper_notes,
      status: firstQuote.status,
      count: allQuotes.length // Number of quotes
    };
  }

  formatQuoteTimes(quote: any): string {
    if (!quote?.times || quote.times.length === 0) {
      return '';
    }
    return quote.times.map(time => this.timePipe.transform(time)).join(', ');
  }

  formatQuoteIndicator(quote: any): string {
    if (!quote) {
      return '';
    }

    // Format amount using the same logic as tcurrency pipe
    let formattedAmount = '$0';
    if (quote.amount) {
      const normalizedValue = Math.sqrt(quote.amount * quote.amount);
      const valueWithDecimal = normalizedValue / 100;
      const strValue = quote.amount % 100 > 0 ? valueWithDecimal.toFixed(2) : valueWithDecimal.toString();
      const str = strValue.toString().split('.');
      str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const strValueWithCommas = str.join('.');
      formattedAmount = quote.amount < 0 ? '-$' + strValueWithCommas : '$' + strValueWithCommas;
    }

    let datesText = '';
    if (quote.dates && quote.dates.length > 0) {
      datesText = quote.dates
        .map(date => this.tidyDatePipe.transform(date, 'LLL d'))
        .join(', ');
    } else if (quote.date) {
      datesText = this.tidyDatePipe.transform(quote.date, 'LLL d');
    }

    if (datesText) {
      return `Quote Sent: ${formattedAmount} for ${datesText}`;
    } else {
      return `Quote Sent: ${formattedAmount}`;
    }
  }

  patchLastSentQuote() {
    const aggregatedQuote = this.getAllQuotesForJob();
    if (!aggregatedQuote) {
      return;
    }
    this.priceLaterForm.patchValue({
      amount: aggregatedQuote?.amount ? (aggregatedQuote?.amount / 100)?.toString() : '',
      notes: aggregatedQuote?.homekeeper_notes || ''
    });
  }

  checkShouldShowBigSpender(cleaning) {
    if (!this.privateClients || this.privateClients.length === 0) {
      return false;
    }
    const isCleaningFromPrivateClient = this.privateClients.some(client => client?.id === cleaning?.customer_id);
    return cleaning?.customer_is_premium && !isCleaningFromPrivateClient;
  }

  buildJobTimeItems() {
    const array: any = [];
    this.jobsGroupedByJobId.map((job) => {
      job.jobs.map((item) => {
        array.push({
          value: item.emergency_cleaning_request_id,
          viewValue: this.timePipe.transform(item.time) + ' ' + new TranslationPipe().transform('on') + ' ' + this.tidyDatePipe.transform(item.date, 'LLL d')
        });
      });
    });
    return array;
  }

  getJobsFromClientCount() {
    const array: any = [];
    this.jobsGroupedByJobId.map((group) => {
      group.jobs.map((job) => {
        const isSameClient = job.customer_id == this.cleaning.customer_id;
        if (isSameClient && !array.includes(job.job_id)) {
          array.push((job.job_id));
        }
      });
    });
    return array.length;
  }

  async setMap() {
    mapboxgl.accessToken = AppConfig.MAPBOX_KEY;
    let centerLongitude = this.homeLongitude;
    let centerLatitude = this.homeLatitude;
    if (this.homeLongitude == null || this.homeLongitude == undefined) {
      centerLongitude = this.cleaning.longitude;
      centerLatitude = this.cleaning.latitude;
    } else {
      centerLongitude += this.cleaning.longitude;
      centerLatitude += this.cleaning.latitude;
      centerLongitude = centerLongitude / 2;
      centerLatitude = centerLatitude / 2;
    }
    const mapElementId = this.mapUid;
    await this.awaitMapElement(mapElementId);
    const map = new mapboxgl.Map({
      container: mapElementId,
      style: 'mapbox://styles/mapbox/light-v10',
      center: [ centerLongitude, centerLatitude ],
      zoom: 8,
      maxZoom: 11,
      minZoom: 5
    });
    this.addOppMarker(map);
    this.addHomeMarker(map);
  }

  addOppMarker(map) {
    const el = document.createElement('div');
    const letter = String.fromCharCode(65);
    el.className = 'marker';
    el.innerHTML = `<span class="map-marker">${letter}</span>`;
    this.createMarkerInstance({map, el, longLat: [ this.cleaning.longitude, this.cleaning.latitude ]})
  }

  async addHomeMarker(map) {
    const el = document.createElement('div');
    el.className = 'marker';
    el.innerHTML = `<image src="assets/img/home-black.svg" style="height: 30px"></image>`;
    this.createMarkerInstance({map, el, longLat: [ this.homeLongitude, this.homeLatitude ]});
  }

  createMarkerInstance(obj) {
    const {el, longLat, map} = obj;
    new mapboxgl.Marker(el)
      .setLngLat(longLat)
      .addTo(map);
  }

  async awaitMapElement(mapId, atempts = 1) {
    const mapElement = document.getElementById(mapId);
    if(!mapElement && atempts < 4) {
      await promiseUtils.sleep(100);
      await this.awaitMapElement(mapId, (atempts + 1));
    }
  }

  openBookingProtectionLearnMore = () => {
    this.iabUtils.openUrl('https://help.tidy.com/pros/booking-protection');
  }

  openBonusLearnMore = () => {
    this.iabUtils.openUrl('https://help.tidy.com/pros/how-to-get-clients-from-tidy#select-clients-who-need-you');
  }

  openStandbyLearnMore = () => {
    this.iabUtils.openUrl('https://help.tidy.com/pros/how-to-get-clients-from-tidy#select-clients-who-need-you');
  }

  confirmPlanCoop = () => {
    if (!this.validateInlineCredentials()) return;
    this.confirmingPlanCoop = true;
    this.pageTitle = 'Are You Sure?';
    this.getPlanDates();
  }

  getPlanDates() {
    this.planDates = [];

    const date = moment(this.cleaning.date, 'YYYY-MM-DD');

    for (let i = 0; i <= 4; i++) {
      const cloneDate = date.clone();
      const planDate = cloneDate.add(i * 7, 'days');
      this.planDates.push(planDate);
    }
  }

  async showConfirmDeclineCleaningAlert(): Promise<void> {
    const options = {
      header: 'Decline Request?',
      message: 'Are you sure you want to decline this job?',
    }
    const confirmAlert = await this.utils.showConfirmAlert(options);
    confirmAlert.onDidDismiss().then((data) => {
      if (data.role === 'confirm') {
        this.declineCleaning();
      }
    });
  }

  async declineCleaning() {
    const loading = await this.utils.showLoading();
    try {
      await this.homekeepers.declineCleaning(this.cleaning.emergency_cleaning_request_id);
      loading.dismiss();
      this.navCtrl.navigateForward('add');
    } catch (error) {
      loading.dismiss();
      console.error(error);
      this.apiError = error.error ? error.error.message : error.message;
      this.utils.showError(`Error declining cleaning: ${this.apiError}`);
    }
  }

  async claimCleaning() {
    if (!this.validateInlineCredentials()) return;

    this.apiError = '';
    if (this.inlineCredentialFields.length > 0) {
      try {
        await this.submitInlineCredentials();
      } catch (err) {
        this.apiError = 'Error adding credentials. Please try again.';
        return;
      }
    }

    const hkId = await this.homekeepers.hkId();
    try {
      const data = {
        booking_protection_enabled: this.didGoLive ? this.bookingProtection : false,
        emergency_cleaning_request_id: this.form.value.jobTime,
        type: this.cleaning.type,
        id: hkId
      };
      await this.homekeepers.claimCleaning(data);
      this.mwService.sendMomentToBackend(mwMoments.claimCoop, 'claim-job', this.cleaning.job_id);
      const params = this.mountSuccessPageParams();
      this.navCtrl.navigateForward('success', params);
    } catch (err) {
      const errorMessage = err.error ? err.error.message : err.message;
      if (err.status === 403 && errorMessage?.includes('Missing mandatory credentials')) {
        this.apiError = 'You need to add the required credentials before you can claim this job.';
      } else {
        this.apiError = errorMessage;
        this.showCleaningNoLongerAvailable();
      }
    }
  }

  mountQuoteAddedParams(): SuccessPageParamsModel {
    return {
      header: 'Quote Added',
      body: 'Your quote has been added to the job.',
      buttonText: 'Ok',
      buttonRoute: 'jobs'
    };
  }

  mountSuccessPageParams(): SuccessPageParamsModel {
    return {
      header: 'Job Added',
      body: this.cleaning?.is_private ? 'Nice work! You just booked with your client.' : 'Nice work! You just gained a new client.',
      buttonText: 'Ok',
      buttonRoute: 'jobs'
    };
  }

  showCleaningNoLongerAvailable() {
    this.navCtrl.navigateForward('success', {
      header: 'Opportunity No Longer Available',
      body: 'Unfortunately this opportunity was taken by someone else.  They can be quite competitive.',
      buttonText: 'Ok',
      buttonRoute: 'add'
    });
  }

  enableClaimButton() {
    this.claimButtonDisabled = false;
  }

  async openOtherOptionsPage() {
    const jobsFromSameClient = await this.homekeepers.getJobOpportunitiesForClient(this.cleaning.customer_id);
    const parsedJobsForClient: any = await this.claimJobs.parseDays(jobsFromSameClient);
    this.jobsFromSameClient = this.claimJobs.getJobsFromSameClient(parsedJobsForClient.currentWeek, this.cleaning);
    const params = {
      jobsFromSameClient: this.jobsFromSameClient,
      clientName: this.cleaning.customer_first_name
    }
    this.navCtrl.navigateForward('other-options', params);
  }

  parseServiceLength(name) {
    const lastIndex = name.lastIndexOf(" ");
    return name.substring(0, lastIndex);
  }

  async getHkHomeData(): Promise<Array<number>> {
    const hk = await this.me.load();
    this.homeLongitude = hk.user.longitude;
    this.homeLatitude = hk.user.latitude;
    return [this.homeLongitude, this.homeLatitude];
  }

  getExistingQuotesForJob(): any[] {
    if (!this.cleaning?.job_id) {
      return [];
    }

    if (this.allJobOpportunities && this.allJobOpportunities.length > 0) {
      return this.allJobOpportunities
        .filter(opp => opp.job_id === this.cleaning.job_id && opp.vendor_outreach_request_quote)
        .map(opp => opp.vendor_outreach_request_quote)
        .filter(quote => quote);
    }

    if (this.cleaning?.vendor_outreach_request_quote) {
      return [this.cleaning.vendor_outreach_request_quote];
    }

    return [];
  }

  buildQuoteDaysAndTimes() {
    const existingQuotes = this.getExistingQuotesForJob();

    const existingQuoteTimes = new Set<string>();
    existingQuotes.forEach(quote => {
      if (quote.date && quote.time) {
        let normalizedTime = '';
        const timeStr = quote.time.toString();
        try {
          if (timeStr.length > 5) {
            normalizedTime = moment(quote.time, 'HH:mm:ss').format('HH:mm');
          } else {
            normalizedTime = moment(quote.time, 'HH:mm').format('HH:mm');
          }
          existingQuoteTimes.add(`${quote.date}:${normalizedTime}`);
        } catch (err) {
          console.warn('Error parsing quote time:', quote.time, err);
        }
      }
    });

    const jobGroup = this.jobsGroupedByJobId?.find(group => group.job_id === this.cleaning.job_id);

    if (!jobGroup || !jobGroup.jobs || jobGroup.jobs.length === 0) {
      const date = this.cleaning.date || moment().format('YYYY-MM-DD');
      const dateLabel = this.tidyDatePipe.transform(date, 'LLL d');
      let time = '';
      let timeLabel = '';
      let isSelected = false;

      if (this.cleaning.time) {
        const timeStr = this.cleaning.time.toString();
        if (timeStr.length > 5) {
          time = moment(this.cleaning.time, 'HH:mm:ss').format('HH:mm');
        } else {
          time = moment(this.cleaning.time, 'HH:mm').format('HH:mm');
        }
        timeLabel = this.timePipe.transform(this.cleaning.time);

        isSelected = existingQuoteTimes.has(`${date}:${time}`);
      }

      this.quoteDaysAndTimes = [{
        date: date,
        dateLabel: dateLabel,
        selected: isSelected,
        times: time ? [{
          time: time,
          timeLabel: timeLabel,
          selected: isSelected
        }] : []
      }];
      return;
    }

    // Group jobs by date
    const daysMap = new Map<string, any[]>();
    jobGroup.jobs.forEach(job => {
      if (!job.date || !job.time) return;
      const date = job.date;
      if (!daysMap.has(date)) {
        daysMap.set(date, []);
      }
      daysMap.get(date).push(job);
    });

    this.quoteDaysAndTimes = Array.from(daysMap.entries()).map(([date, jobs]) => {
      const dateLabel = this.tidyDatePipe.transform(date, 'LLL d');
      const times = jobs
        .map(job => {
          if (!job.time) return null;
          const timeStr = job.time.toString();
          let time = '';
          try {
            if (timeStr.length > 5) {
              time = moment(job.time, 'HH:mm:ss').format('HH:mm');
            } else {
              time = moment(job.time, 'HH:mm').format('HH:mm');
            }
          } catch (err) {
            console.warn('Error parsing time:', job.time, err);
            return null;
          }

          const isSelected = existingQuoteTimes.has(`${date}:${time}`);

          return {
            time: time,
            timeLabel: this.timePipe.transform(job.time),
            selected: isSelected
          };
        })
        .filter(time => time !== null)
        .sort((a, b) => a.time.localeCompare(b.time));

      const hasSelectedTime = times.some(t => t.selected === true);

      return {
        date: date,
        dateLabel: dateLabel,
        selected: hasSelectedTime,
        times: times
      };
    }).sort((a, b) => moment(a.date).diff(moment(b.date))); // Sort by date
  }

  toggleDaySelection(dayIndex: number, event?: any) {
    // Prevent double-toggling if called from both click and checkbox change
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    const day = this.quoteDaysAndTimes[dayIndex];
    day.selected = !day.selected;
    // When unchecking a day, uncheck all its times
    if (!day.selected) {
      day.times.forEach(time => time.selected = false);
    } else {
      // When checking a day, check all its times
      day.times.forEach(time => time.selected = true);
    }
  }

  onTimeCheckboxChange(dayIndex: number, timeIndex: number, checked: boolean) {
    const time = this.quoteDaysAndTimes[dayIndex].times[timeIndex];
    // Explicitly set the selected state to the checkbox value
    time.selected = checked === true;

    // Update day selection state based on whether any times are selected
    const day = this.quoteDaysAndTimes[dayIndex];
    const hasAnySelectedTime = day.times.some(t => t.selected === true);
    // Only unselect the day if no times are selected (this will collapse the card)
    // Otherwise, keep it selected so the card stays open
    if (!hasAnySelectedTime) {
      day.selected = false;
    } else {
      // Keep day selected to keep card open, even if not all times are selected
      day.selected = true;
    }
  }

  toggleTimeSelection(dayIndex: number, timeIndex: number, toggle: boolean = true) {
    const time = this.quoteDaysAndTimes[dayIndex].times[timeIndex];
    if (toggle) {
      time.selected = !time.selected;
    }
    // Keep the day selected (card open) if any time is selected
    // The day checkbox state reflects whether all times are selected, but card stays open
    const day = this.quoteDaysAndTimes[dayIndex];
    const hasAnySelectedTime = day.times.some(t => t.selected);
    // Only unselect the day if no times are selected (this will collapse the card)
    // Otherwise, keep it selected so the card stays open
    if (!hasAnySelectedTime) {
      day.selected = false;
    } else {
      // Keep day selected to keep card open, even if not all times are selected
      day.selected = true;
    }
  }

  getSelectedDateAndTimes(): { timeslots: Array<{ date: string, times: string }> } {
    // Collect all days that have at least one selected time (regardless of day.selected state)
    // This ensures we only include days with actual time selections
    const daysWithSelectedTimes = this.quoteDaysAndTimes.filter(day =>
      day.times && day.times.length > 0 && day.times.some(t => t.selected === true)
    );

    if (daysWithSelectedTimes.length === 0) {
      // No selections, return empty timeslots array
      return { timeslots: [] };
    }

    // Build timeslots array: one entry per date with its selected times
    const timeslots = daysWithSelectedTimes
      .map(day => {
        // Get selected times for this day, sorted
        const selectedTimes = day.times
          .filter(t => t && t.selected === true) // Explicitly check for true
          .map(t => t.time)
          .filter(time => time) // Ensure time exists
          .sort(); // Sort alphabetically

        return {
          date: day.date,
          times: selectedTimes.join(',') // Comma-separated times for this date
        };
      })
      .filter(slot => slot.times.length > 0) // Only include slots with times
      .sort((a, b) => moment(a.date).diff(moment(b.date))); // Sort by date chronologically

    return { timeslots };
  }

  async submitQuoteRequest() {
    this.submitted = true;
    this.apiError = '';

    if (this.priceLaterForm.invalid) {
      return;
    }

    try {
      const hkId = await this.homekeepers.hkId();
      const amountInCents = removeCurrencyMask(this.priceLaterForm.value.amount);

      // Extract timeslots from selected days/times
      const { timeslots } = this.getSelectedDateAndTimes();

      if (!timeslots || timeslots.length === 0) {
        this.apiError = 'Please select at least one time for the quote.';
        return;
      }

      const payload = {
        job_id: this.cleaning.job_id,
        homekeeper_id: hkId,
        amount: amountInCents,
        timeslots: timeslots,
        times: '', // Empty string as per new API structure
        homekeeper_notes: this.priceLaterForm.value.notes
      };

      const url = 'api/v1/homekeeper/vendor-outreach-request-quotes';
      await this.httpClient.post(url, payload);

      this.mwService.sendMomentToBackend(mwMoments.claimCoop, 'claim-job', this.cleaning.job_id);
      const params = this.mountQuoteAddedParams();
      this.navCtrl.navigateForward('success', params);
    } catch (err) {
      this.apiError = err.error ? err.error.message : err.message;
      console.error('Error submitting quote request:', err);
    }
  }

  getAllQuoteIdsForJob(): number[] {
    if (!this.cleaning?.job_id) {
      return [];
    }

    if (this.allJobOpportunities && this.allJobOpportunities.length > 0) {
      const allQuotes = this.allJobOpportunities
        .filter(opp => opp.job_id === this.cleaning.job_id && opp.vendor_outreach_request_quote)
        .map(opp => opp.vendor_outreach_request_quote)
        .filter(quote => quote && quote.id);

      return allQuotes.map(quote => quote.id);
    }

    if (this.cleaning?.vendor_outreach_request_quote?.id) {
      return [this.cleaning.vendor_outreach_request_quote.id];
    }

    return [];
  }

  async showConfirmCancelQuoteAlert(): Promise<void> {
    const options = {
      header: 'Cancel Quote?',
      message: 'Are you sure you want to cancel this quote?',
    }
    const confirmAlert = await this.utils.showConfirmAlert(options);
    confirmAlert.onDidDismiss().then((data) => {
      if (data.role === 'confirm') {
        this.cancelQuote();
      }
    });
  }

  async cancelQuote() {
    const loading = await this.utils.showLoading();
    const quoteIds = this.getAllQuoteIdsForJob();

    if (quoteIds.length === 0) {
      this.apiError = 'No quotes found to cancel.';
      return;
    }

    try {
      const cancelPromises = quoteIds.map(quoteId => {
        const url = `api/v1/homekeeper/vendor-outreach-request-quotes/${quoteId}/cancel`;
        return this.httpClient.post(url, {});
      });

      await Promise.all(cancelPromises);

      const jobId = this.cleaning.job_id;
      const jobOpportunitiesForJob = await this.homekeepers.getJobOpportunitiesForJob(jobId);
      this.allJobOpportunities = jobOpportunitiesForJob;

      const updatedCleaning = jobOpportunitiesForJob.find(opp =>
        opp.emergency_cleaning_request_id === this.cleaning.emergency_cleaning_request_id
      );
      if (updatedCleaning) {
        this.cleaning = updatedCleaning;
      }

      this.priceLaterForm.reset();
      this.apiError = '';
      loading.dismiss();
      this.utils.showSuccess('Quote cancelled successfully');
    } catch (err) {
      this.apiError = err.error ? err.error.message : err.message;
      this.utils.showError('Error canceling quote: ' + this.apiError);
      console.error('Error canceling quote:', err);
      loading.dismiss();
    }
  }
}
